var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"id":"mytab"}},_vm._l((_vm.tab),function(item,index){return _c('li',{key:index,class:{ active: index == _vm.now },style:({ width: _vm.width }),on:{"click":function($event){return _vm.change(item, index)}}},[_vm._v("\n    "+_vm._s(item.title)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1774197e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/myTab.vue
// module id = null
// module chunks = 